import { FileUploadArea } from './FileUploadArea';

export * from './FileUploadArea';
export * from './FileUploadArea.types';

export default FileUploadArea;
